import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        width: "100vw",
        backgroundColor: "#000a4f",
        color: "white",
        clipPath: "ellipse(85% 90% at 50% 100%)",
        zIndex: 1000,
      }}
      className="py-4 d-lg-none floating-footer"
    >
      <div className="container-fluid" style={{ padding: 0 }}>
        <div className="row text-center pt-2">
          <div className="col">
            <Link to="/dashboard">
              <i className="fa-solid fa-house text-white fa-lg floating-icon"></i>
              <div className="text-white">Home</div>
            </Link>
          </div>
          <div className="col">
            <Link to="/customers">
              <i className="fa-solid fa-users text-white fa-lg floating-icon"></i>
              <div className="text-white">Customers</div>
            </Link>
          </div>
          <div className="col">
            <Link to="/leads">
              <i className="fa-solid fa-headphones text-white fa-lg floating-icon"></i>
              <div className="text-white">Leads</div>
            </Link>
          </div>
          <div className="col">
            <Link to="/todo">
              <i className="fa-solid fa-calendar-check text-white fa-lg floating-icon"></i>
              <div className="text-white">Todo</div>
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
